import {Component, OnInit} from "@angular/core";
import {paramsHelper} from "../../helpers/params-helper";
import {DOCUMENT_TYPES} from "../../enums/enums";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {IDocument} from "../../interfaces/document.definition";
import {BusService} from "../../services/bus.service";

@Component({
  selector:"atlases-page",
  templateUrl:"./atlases-page.component.html",
  styles:[]
})
export class AtlasesComponent implements OnInit {

  document:IDocument;

  pageParams = paramsHelper.page()
    .setDisabledOptionVisible(false)
    .setTitle("Атласы");

  collectionParams = paramsHelper.collection()
    .setEndpointId(E_ENDPOINTS.API)
    .setDuplicateEnabled(false)
    .setObjectType(DOCUMENT_TYPES.ATLAS)
    .setDefaultListLabels()
    .setItemLabelQuery("name")

  constructor(private busService: BusService) {
  }

  ngOnInit(){
    this.busService.onDocumentUpdated
      .subscribe(e => this.updateDocument(e.document as IDocument));

  }

  private updateDocument(document:IDocument){
    this.document = document;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/atlases/atlases-page.component.ts